// extracted by mini-css-extract-plugin
module.exports = {"question":"Questions_question__mkooY","qtitle":"Questions_qtitle__CphSq"};